/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from 'react';

import { withStyles, createTheme, ThemeProvider } from '@material-ui/core/styles'
import { Typography, Tooltip, InputBase, IconButton, Divider, CircularProgress, Paper, FormControlLabel, Switch, Button } from '@material-ui/core';
import { Edit, Done, Clear, ArrowUpward } from '@material-ui/icons';

import MaterialTable, { MTableToolbar } from "material-table";
import table_icons from "../../../tableIcons";

import Actions from '../../../../fluid/Actions/ActionFactory'
import Result from '../../../Results/Result'

const DOMPurify = require('dompurify')(window);

const blue_theme = createTheme({
    palette: {
        primary: {
          main: '#2296f3',
        },
        secondary: {
            main: '#dc014e',
        }
      },
})

const styles = theme => ({

})

class Distribution extends Component {
    state = {
        edit_index : null,
        active_topic_id : null,
        active_topic_name : null,
        active_topic_name_edit : null,
        active_topic_top_tickets : null,
        active_topic_top_terms : null,
        active_topic_proportion : null,
        editing_name : false,
        updating_name : false,
        content_height : null,
        content_width : null,
        show_weights : false,
        render_ready : false,
        hasChildren : false
    }

    panel = React.createRef()
    distribution = React.createRef()

    componentWillMount () {
        console.log('Distribution : ', this.props.themes)
        this.selectTopic(this.props.themes.response[0].topicId)
    }

    componentDidMount () {
        let content_height = this.panel.current.clientHeight - this.distribution.current.clientHeight
        console.log("Distribution Content Height :", content_height)

        this.setState({
            ...this.state,
            content_height : content_height,
            render_ready : true
        })
    }

    selectTopic = (topicId) => {
        let topic_name

        let topic_index = this.props.themes.response.findIndex(theme => theme.topicId === topicId)
        let topic = this.props.themes.response[topic_index]
        let top_tickets = this.props.themes.response[topic_index].topTickets
        let top_terms = this.props.themes.response[topic_index].topTopicalTerms
        let proportion = this.props.themes.response[topic_index].displayLabel
        let has_children = false
        if (this.props.themes.response[topic_index].children) {
            has_children = true
        }
        topic_name = topic.topicName
        this.setState({
            ...this.state,
            active_topic_id : topicId,
            active_topic_name : topic_name,
            active_topic_name_edit : topic_name,
            active_topic_top_terms : top_terms,
            active_topic_top_tickets : top_tickets,
            active_topic_proportion : proportion,
            hasChildren : has_children
        }, () => console.log("Distribution State : ", this.state))
    }
    

    renderDistribution = () => {
        return (
            <div>
                <div style = {{width : '100%', marginTop : '5px', display : 'flex', flexDorection : 'row', alignItems : 'baseline'}}>
                    {this.renderDistributionChart()}
                </div>
                {this.renderTopicName()}
                <Divider/>
            </div>
        )
    }

    renderName = (topicId) => {
        let topic_index = this.props.themes.response.findIndex(theme => theme.topicId === topicId)

        if (topicId === this.state.active_topic_id) {
            return (
                <Typography
                    style = {{
                        width : '100%',
                        display : 'block',
                        fontWeight : 600
                    }}
                    noWrap
                    variant = 'caption'
                >{this.props.themes.response[topic_index].topicName === 'Unnamed' ? this.props.themes.response[topic_index].topicIndex : this.props.themes.response[topic_index].topicName}
                </Typography>
            )
        } else {
            return (
                <Typography
                    style = {{
                        maxWidth : '100%',
                        display : 'block'
                    }}
                    noWrap
                    variant = 'caption'
                >{this.props.themes.response[topic_index].topicName === 'Unnamed' ? this.props.themes.response[topic_index].topicIndex : this.props.themes.response[topic_index].topicName}
                </Typography>
            )
        }
    }

    handleNameChange = (newValue) => {
        this.setState({
            ...this.state ,
            active_topic_name_edit : newValue
        }, () => console.log("Theme State: ", this.state))
    }

    setTopicName = () => {
        this.setState({
            ...this.state,
            updating_name : true
        }, () => {
            Actions("http_request", {
                url : '/sainapse/insights/topics/name?ic_name=' + this.props.themes.ic_name,
                method : "post",
                data : {
                    [this.state.active_topic_id] : this.state.active_topic_name_edit
                }
            }).then(res => {
                this.setState({
                    ...this.state,
                    active_topic_name : this.state.active_topic_name_edit,
                    updating_name : false,
                    editing_name : false
                }, () => {
                    this.props.get_insights()
                })
            }).catch(err => {
    
            })
        })
    }

    renderTopicName = () => {
        if (this.state.editing_name) {
            return (
                <div style = {{display : 'flex', flexDirection : 'row', alignItems : 'center', padding :'5px'}}>
                    <InputBase
                        style = {{width : '25%'}}
                        value = {this.state.active_topic_name_edit}
                        onChange = {(event) => this.handleNameChange(event.target.value)}
                        onKeyDown = {(e) => {
                            if (e.key === "Enter") {
                                this.setTopicName()
                            }
                        }}
                        endAdornment = {
                            <Fragment>
                                {this.state.updating_name ? <CircularProgress color="primary" size={20} /> : null}
                            </Fragment>
                        }
                    />
                    <IconButton style = {{marginLeft: '10px'}}size = 'small' color = 'primary' onClick = {this.setTopicName}>
                        <Done fontSize = 'small'/>
                    </IconButton>
                    <IconButton size = 'small' color = 'secondary' onClick = {() => {
                        this.setState({
                            ...this.state,
                            editing_name : false
                        }, () => this.selectTopic(this.state.active_topic_id))
                    }}>
                        <Clear fontSize = 'small'/>
                    </IconButton>
                </div>
            )
        } else {
            return (
                <div style = {{display : 'flex', flexDirection : 'row', alignItems : 'center', padding :'5px'}}>
                    <Typography style = {{marginRight : '10px'}} variant = 'button' color = 'primary'>{this.state.active_topic_proportion}</Typography>
                    <Typography style = {{fontWeight : 600, fontSize : '15px'}} variant = 'h6'>{this.state.active_topic_name}</Typography>
                    <IconButton style = {{marginLeft : '10px'}} size = 'small' onClick = {() => {
                        this.setState({
                            ...this.state,
                            editing_name : true
                        })
                    }}>
                        <Edit fontSize = 'small'/>
                    </IconButton>
                    {this.state.hasChildren ? <Button color = 'primary' size = 'small' onClick = {() => this.props.switch_level(1)}>View next level themes</Button> : null}
                </div>
            )
        }
    }

    renderDistributionChart = () => {
        let chart = this.props.themes.response.map((theme, i) => {
            return this.renderEachDistribution(theme)
        })

        return chart
    }

    renderEachDistribution = (theme) => {
        let proportion = parseFloat(theme.overallTopicProportion)
        let display = true
        if (proportion < 3) {
            display = false
        }

        let selected = this.state.active_topic_id === theme.topicId

        if (proportion !== 0) {
            return (
                <div style = {{
                    width : theme.overallTopicProportion + "%",
                    padding : '2px',
                    cursor : 'pointer'
                }}
                onClick = {() => selected ? null : this.selectTopic(theme.topicId)}
                >
                    <div style = {{width : '100%'}}>
                        {DOMPurify.sanitize(this.renderName(theme.topicId))}
                    </div>
                    <Tooltip title = {theme.topicName + " || " + theme.displayLabel}>
                        <div style = {{
                            width : '100%',
                            height : selected ? '35px' : '30px',
                            backgroundColor : selected ? '#2296f3' : 'rgba(34, 150, 243, 0.5)',
                            boxShadow : selected  ? '0px 3px 12px 2px rgba(0,0,0,0.25)' : null,
                            display : 'flex',
                            flexDirection : 'row',
                            alignItems : 'center',
                            padding : '3px'
                        }}>
                            {display ? <Typography
                                style = {{
                                    color : selected  ? '#FFFFFF' : '#000000'
                                }}
                                variant = {selected ? 'button' : 'caption'}
                            >
                                {DOMPurify.sanitize(theme.displayLabel)}
                            </Typography> : null}
                        </div>
                    </Tooltip>
                </div>
            )
        } else {
            return null
        }
    }

    renderTerms = () => {
        if (this.state.show_weights) {
            return this.renderTermsTable()
        } else {
            return this.renderFWeightTerms()
        }
    }

    renderTermsTable = () => {
        return (
            <MaterialTable
                style = {{width : '100%'}}
                columns = {[
                    {
                        title : "Descriptor",
                        field : "term"
                    },
                    {
                        title : "Weight",
                        fields : "displayWeight",
                        render: termData => {
                            return(
                                <div style = {{display: 'flex', flexDirection: 'row'}}>
                                    <div style = {{width: '70%', backgroundColor: '#c4c4c4', height: '20px'}}>
                                        <div style = {{width: termData.displayWeight.toString() + '%', backgroundColor: '#00baff', height: '100%'}}></div>
                                    </div>
                                    <Typography style = {{marginLeft: '5px'}}>{termData.displayWeight.toString() + '%'}</Typography>
                                </div>
                            )
                        }
                    }
                ]}
                data = {this.state.active_topic_top_terms}
                options = {{
                    paging: false,
                    loadingType: 'overlay',
                    search: false,
                    showEmptyDataSourceMessage: true,
                    headerStyle: { position: 'sticky', top: 0 },
                    maxBodyHeight: this.state.content_height - 100 + "px",
                    toolbar : false
                }}
            />
        )
    }

    renderFWeightTerms = () => {
        let max_weight = this.state.active_topic_top_terms[0].weight 
        let min_weight = this.state.active_topic_top_terms[this.state.active_topic_top_terms.length - 1].weight
        let max_fWeight = 800
        let min_fWeight = 200

        let terms = this.state.active_topic_top_terms.map(term => {
            return (
                <Paper variant = 'outlined' style = {{
                    width : '30%',
                    display : 'flex',
                    flexDirection : 'row',
                    justifyContent : 'center',
                    alignItems : 'center',
                    padding : '5px',
                    marginBottom : '10px'
                }}>
                    <Typography variant = 'body1' style = {{fontWeight : (term.weight * 800) / max_weight}}>{term.term}</Typography>
                </Paper>
            )
        })

        return terms
    }

    toggleWeights = () => {
        this.setState({
            ...this.state,
            show_weights : !this.state.show_weights
        })
    }

    renderTopTerms = () => {
        return (
            <div style = {{width : '40%', height : '100%', maxHeight : '100%', padding : '5px', borderRight : '1px solid rgba(0,0,0,0.12)'}}>
                <Paper square elevation = {4} style = {{width : '100%', maxHeight: '100%', overflow:'auto', padding : '10px'}}>
                    <div style = {{display : 'flex', flexDirection : 'row', alignItems : 'baseline'}}>
                        <Typography style = {{fontWeight : 600, flexGrow : 1}} variant = 'body2'>Discovered descriptors</Typography>
                        <FormControlLabel
                            control={
                                <Switch
                                    color="secondary"
                                    size="small"
                                    checked={this.state.show_weights}
                                    onChange={this.toggleWeights}
                                    name="weights"
                                />
                            }
                            label={
                                <Typography variant="body2" color="textSecondary">
                                    Show Weights
                                </Typography>
                            }
                            labelPlacement="start"
                        />
                    </div>
                    <Divider/>
                    <div style = {{width : '100%', display : 'flex', flexDirection : 'row', flexWrap : 'wrap', justifyContent : 'space-around', paddingTop : '10px'}}>
                        {this.renderTerms()}
                    </div>
                </Paper>
            </div>
        )
    }

    getKeyTerms = () => {
        if (this.state.active_topic_id !== null) {
            let key_terms = []
            this.state.active_topic_top_terms.map(topicalTerm => {
                key_terms.push(topicalTerm.term)
            })

            return key_terms
        } else {
            return []
        }
    }

    getSearchString = () => {
        return ''
    }

    renderTopTickets = () => {
        var toPX = require("to-px");
        let responseArray = this.state.active_topic_top_tickets.map((element) => element.attributes);
        let resultsJson = [
            {
                ic_name: this.state.active_topic_name,
                response: { 
                    result: responseArray,
                    t: ""
                } 
            }
        ]

        console.log("Theme Data : ", resultsJson)
        let ic_list = [this.state.active_topic_name]

        return (
            <Result 
                key={this.state.active_topic_id}
                height = {this.state.content_height - 10} 
                width = {toPX("65vw")}
                results = {resultsJson}
                ic_list = {ic_list}
                reco_label = {"Representative Cases for " + this.state.active_topic_name.toUpperCase()}
                class_label = ""
                class_results = {[]}
                drl_url = {this.props.drl_url}
                searching = {this.state.searching}
                search_string = {this.getSearchString}
                key_terms = {this.getKeyTerms()}
            />
        )
    }

    render() {
        const { classes } = this.props
        return (
            <ThemeProvider theme = {blue_theme}>
                <div ref = {this.panel} style = {{width : '100%', height : '100%', maxHeight : '100%'}}>
                    <div ref = {this.distribution} style = {{width : '100%', padding : '5px'}}>
                        <div style = {{display : 'flex', flexDirection : 'row', alignItems :'center'}}>
                            {this.props.level === 1 ? <Tooltip title = "Move 1 level up"><IconButton color = 'primary' size = 'small' onClick = {() => this.props.switch_level(0)}><ArrowUpward fontSize = 'small'/></IconButton></Tooltip> : null}
                            <Typography style = {{fontWeight : 600, fontSize : '15px'}} variant = 'h6'>{this.props.level === 0 ? "Discovered Themes" : "Other discovered themes"}</Typography>
                        </div>
                        <Divider style = {{marginBottom : '5px'}} />
                        {this.renderDistribution()}
                    </div>
                    <div style = {{width : '100%', height : this.state.content_height, display : 'flex', flexDirection : 'row'}}>
                        {this.state.updating_name === false ? this.renderTopTerms() : null}
                        {this.state.render_ready && this.state.updating_name === false ? this.renderTopTickets() : null}
                    </div>
                </div>
            </ThemeProvider>
        );
    }
}

export default withStyles(styles)(Distribution);